"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.memoize"));

var _lodash2 = _interopRequireDefault(require("lodash.debounce"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uiKit = require("@devsta/ui-kit");

var _vars = require("@devsta/ui-kit/dist/common/styles/vars");

var _commonReact = require("@devsta/common-react");

var _clientAwsS = require("@devsta/client-aws-s3");

var _RemoveMembershipModal = _interopRequireDefault(require("./RemoveMembershipModal"));

var _InviteUsersModal = _interopRequireDefault(require("../../../../../../../common/components/InviteUsersModal"));

var _UsersListItem = _interopRequireDefault(require("./UsersListItem"));

var _utils = require("../../../../../../../common/utils");

require("../styles/_users-list.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var MODAL = {
  INVITE_USERS: 'INVITE_USERS',
  REMOVE_USER: 'REMOVE_USER',
  RESET_CREDENTIALS: 'RESET_CREDENTIALS',
  RESEND_INVITATION: 'RESEND_INVITATION'
};
var STATUS_FILTER_ITEMS = [{
  label: 'All Users',
  value: void 0
}, {
  label: 'Active',
  value: 'ACCEPTED'
}, {
  label: 'Invite Pending',
  value: 'PENDING'
}];
var InviteUsersButton = (0, _commonReact.requiresPermission)({
  ComponentToRender: _uiKit.Button,
  requiredPermission: 'MANAGE_ORGANISATION'
});

var UsersList = /*#__PURE__*/function (_Component) {
  _inherits(UsersList, _Component);

  var _super = _createSuper(UsersList);

  function UsersList(props) {
    var _this;

    _classCallCheck(this, UsersList);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleConfirmModal", (0, _lodash.default)(function (apiFunction) {
      return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var modalMember, _yield$apiFunction, error;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                modalMember = _this.state.modalMember;

                if (modalMember) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return");

              case 3:
                _context.next = 5;
                return apiFunction(modalMember.userEmail);

              case 5:
                _yield$apiFunction = _context.sent;
                error = _yield$apiFunction.error;

                if (!error) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return");

              case 9:
                _this.closeModal();

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }));

    _defineProperty(_assertThisInitialized(_this), "handleRoleChange", (0, _lodash.default)(function (membershipId) {
      return /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref2) {
          var value, updateOrgMembership, orgMemberships, _yield$updateOrgMembe, error, data, role, updatedMemberships;

          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  value = _ref2.value;
                  updateOrgMembership = _this.props.updateOrgMembership;
                  orgMemberships = _this.state.orgMemberships;
                  _context2.next = 5;
                  return updateOrgMembership({
                    membershipId: membershipId,
                    input: {
                      roleId: value
                    }
                  });

                case 5:
                  _yield$updateOrgMembe = _context2.sent;
                  error = _yield$updateOrgMembe.error;
                  data = _yield$updateOrgMembe.data;

                  if (!error) {
                    _context2.next = 10;
                    break;
                  }

                  return _context2.abrupt("return");

                case 10:
                  role = data.updateOrgMembership.role;
                  updatedMemberships = orgMemberships.map(function (membership) {
                    if (membership.membershipId !== membershipId) {
                      return membership;
                    }

                    return _objectSpread(_objectSpread({}, membership), {}, {
                      role: role
                    });
                  });

                  _this.setState({
                    orgMemberships: updatedMemberships
                  });

                case 13:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }();
    }));

    _defineProperty(_assertThisInitialized(_this), "openModal", (0, _lodash.default)(function (_ref4) {
      var member = _ref4.member,
          modalName = _ref4.modalName;
      return function () {
        _this.setState({
          modalMember: member,
          openedModal: modalName
        });
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "gotoUser", (0, _lodash.default)(function (userId) {
      return function () {
        var history = _this.props.history;
        history.rootPush("/user-settings/edit/".concat(userId));
      };
    }));

    _defineProperty(_assertThisInitialized(_this), "handleFiltersChange", (0, _lodash2.default)(function (_ref5) {
      var _ref5$filters = _ref5.filters,
          status = _ref5$filters.status,
          teamId = _ref5$filters.teamId,
          searchTerm = _ref5.searchTerm;

      _this.fetchData({
        status: status,
        teamId: teamId,
        searchTerm: searchTerm
      }, {
        noBlink: true
      });
    }, 300));

    _defineProperty(_assertThisInitialized(_this), "getActionOptions", (0, _lodash.default)(function (member, _ref6) {
      var isShootstaAdmin = _ref6.isShootstaAdmin,
          isShootsta = _ref6.isShootsta;
      var orgPermissions = _this.props.orgPermissions;
      var memberAccepted = member.status === 'ACCEPTED' && Boolean(member.user);
      var actionOptions = [].concat(_toConsumableArray(memberAccepted ? [{
        action: _this.gotoUser(member.user && member.user.userId),
        label: 'View Details'
      }, {
        action: function action() {
          return _this.ghostUser(member.user);
        },
        label: 'Ghost This User',
        requiredPermission: 'MANAGE_CUSTOMERS'
      }, {
        action: _this.openModal({
          member: member,
          modalName: MODAL.RESET_CREDENTIALS
        }),
        label: 'Reset Password',
        requiredPermission: 'MANAGE_ORGANISATION'
      }] : []), _toConsumableArray(!memberAccepted ? [{
        action: _this.openModal({
          member: member,
          modalName: MODAL.RESEND_INVITATION
        }),
        label: 'Resend Invitation',
        requiredPermission: 'MANAGE_ORGANISATION'
      }] : []), [{
        action: _this.openModal({
          member: member,
          modalName: MODAL.REMOVE_USER
        }),
        label: 'Remove User',
        isRed: true,
        requiredPermission: 'MANAGE_ORGANISATION'
      }]);

      if (memberAccepted && isShootsta && !isShootstaAdmin) {
        actionOptions.splice(1, 1);
      }

      return actionOptions.filter(function (_ref7) {
        var requiredPermission = _ref7.requiredPermission;
        return !requiredPermission || (0, _commonReact.hasPermission)(requiredPermission, orgPermissions);
      });
    }));

    _defineProperty(_assertThisInitialized(_this), "ghostUser", /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(user) {
        var _this$props, ghostStart, history;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props = _this.props, ghostStart = _this$props.ghostStart, history = _this$props.history;
                _context3.next = 3;
                return (0, _utils.ghostUserInvoker)({
                  ghostStart: ghostStart,
                  user: user,
                  history: history
                });

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x2) {
        return _ref8.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "fetchData", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var _ref10,
          status,
          teamId,
          searchTerm,
          _ref11,
          noBlink,
          searchOrgMemberships,
          _yield$searchOrgMembe,
          data,
          error,
          _args4 = arguments;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _ref10 = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {}, status = _ref10.status, teamId = _ref10.teamId, searchTerm = _ref10.searchTerm;
              _ref11 = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {
                noBlink: false
              }, noBlink = _ref11.noBlink;
              searchOrgMemberships = _this.props.searchOrgMemberships;
              _context4.prev = 3;

              if (!noBlink) {
                _this.setState({
                  loading: true
                });
              }

              _context4.next = 7;
              return searchOrgMemberships({
                status: status,
                teamId: teamId,
                searchTerm: searchTerm
              });

            case 7:
              _yield$searchOrgMembe = _context4.sent;
              data = _yield$searchOrgMembe.data;
              error = _yield$searchOrgMembe.error;

              if (!(error || !data)) {
                _context4.next = 12;
                break;
              }

              return _context4.abrupt("return", void _this.setState({
                error: true,
                loading: false
              }));

            case 12:
              _this.retrieveBucketKeyUrls(data.searchOrgMemberships);

              _context4.next = 18;
              break;

            case 15:
              _context4.prev = 15;
              _context4.t0 = _context4["catch"](3);

              _this.setState({
                error: true,
                loading: false
              });

            case 18:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[3, 15]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "retrieveBucketKeyUrls", /*#__PURE__*/function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(searchOrgMembershipsData) {
        var _this$props2, apolloClient, organisationId, membershipsWithUserImages;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this$props2 = _this.props, apolloClient = _this$props2.apolloClient, organisationId = _this$props2.organisationId;
                _context5.prev = 1;
                _context5.next = 4;
                return (0, _clientAwsS.replaceBucketKeysWithUrlsInArray)({
                  apiClient: apolloClient,
                  dataArray: searchOrgMembershipsData.map(function (memberships) {
                    return _objectSpread(_objectSpread({}, memberships), {}, {
                      organisationId: organisationId
                    });
                  }),
                  substitutedKeys: [{
                    key: 'user',
                    subKeys: ['imageUrl']
                  }]
                });

              case 4:
                membershipsWithUserImages = _context5.sent;

                _this.setState({
                  orgMemberships: membershipsWithUserImages,
                  loading: false
                });

                _context5.next = 11;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](1);

                _this.setState({
                  orgMemberships: searchOrgMembershipsData,
                  loading: false
                });

              case 11:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[1, 8]]);
      }));

      return function (_x3) {
        return _ref12.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      _this.setState({
        openedModal: void 0
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getConfirmModalProps", function () {
      var _this$props3 = _this.props,
          forgotPassword = _this$props3.forgotPassword,
          resendUserOrgInvite = _this$props3.resendUserOrgInvite;
      var openedModal = _this.state.openedModal;
      return openedModal === MODAL.RESEND_INVITATION ? {
        title: 'Resend Invitation?',
        saveText: 'Resend',
        onSave: _this.handleConfirmModal(resendUserOrgInvite)
      } : {
        title: 'Reset Password?',
        saveText: 'Reset',
        onSave: _this.handleConfirmModal(forgotPassword)
      };
    });

    _defineProperty(_assertThisInitialized(_this), "onMembershipDeleted", function (email) {
      _this.setState(function (_ref13) {
        var orgMemberships = _ref13.orgMemberships;
        return {
          orgMemberships: orgMemberships.filter(function (_ref14) {
            var userEmail = _ref14.userEmail;
            return userEmail !== email;
          })
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getTeamFilter", function () {
      var _this$props4 = _this.props,
          teams = _this$props4.teams,
          displayLimit = _this$props4.displayLimit,
          loadOptions = _this$props4.loadOptions;

      if (teams.length < displayLimit) {
        return [{
          label: 'All Teams',
          value: void 0
        }].concat(_toConsumableArray(teams.map(function (_ref15) {
          var name = _ref15.name,
              teamId = _ref15.teamId;
          return {
            label: name,
            value: teamId
          };
        })));
      }

      return {
        loadOptions: loadOptions,
        placeholder: 'Team',
        isSearchable: true,
        isClearable: true,
        searchPromptText: 'Search for a team'
      };
    });

    _defineProperty(_assertThisInitialized(_this), "renderListItem", function (membership) {
      var _this$props5 = _this.props,
          organisationRoles = _this$props5.organisationRoles,
          orgPermissions = _this$props5.orgPermissions;
      return /*#__PURE__*/_react.default.createElement(_commonReact.AuthorisationConsumer, {
        requiresOrganisation: true
      }, function (_ref16) {
        var isShootstaAdmin = _ref16.isShootstaAdmin,
            isShootsta = _ref16.isShootsta;
        return /*#__PURE__*/_react.default.createElement(_UsersListItem.default, {
          membership: membership,
          organisationRoles: organisationRoles,
          updateMembershipRole: _this.handleRoleChange(membership.membershipId),
          actionOptions: _this.getActionOptions(membership, {
            isShootstaAdmin: isShootstaAdmin,
            isShootsta: isShootsta
          }),
          hasManagePermission: (0, _commonReact.hasPermission)('MANAGE_ORGANISATION', orgPermissions)
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getScrollRef", function () {
      return _this._scrollRef;
    });

    _defineProperty(_assertThisInitialized(_this), "setScrollRef", function (ref) {
      _this._scrollRef = ref;
    });

    _this.state = {
      modalMember: void 0,
      openedModal: void 0,
      loading: false,
      orgMemberships: [],
      error: false
    };
    return _this;
  }

  _createClass(UsersList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchData();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          history = _this$props6.history,
          teams = _this$props6.teams,
          organisationRoles = _this$props6.organisationRoles,
          orgPermissions = _this$props6.orgPermissions,
          ssoConfig = _this$props6.ssoConfig,
          containerSize = _this$props6.containerSize;
      var _this$state = this.state,
          orgMemberships = _this$state.orgMemberships,
          loading = _this$state.loading,
          modalMember = _this$state.modalMember,
          openedModal = _this$state.openedModal,
          error = _this$state.error;

      if (error) {
        return /*#__PURE__*/_react.default.createElement(_commonReact.Error, null);
      }

      var filters = {
        teamId: this.getTeamFilter(),
        status: STATUS_FILTER_ITEMS
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('org-users-list', {
          'org-users-list--small': containerSize.width < _vars.NUMERIC_MEDIA_SIZES.small
        }),
        ref: this.setScrollRef
      }, /*#__PURE__*/_react.default.createElement(_InviteUsersModal.default, {
        visible: openedModal === MODAL.INVITE_USERS,
        onClose: this.closeModal,
        onInvited: this.fetchData,
        teams: teams,
        organisationRoles: organisationRoles,
        orgMemberships: orgMemberships
      }), /*#__PURE__*/_react.default.createElement(_RemoveMembershipModal.default, {
        visible: openedModal === MODAL.REMOVE_USER,
        onClose: this.closeModal,
        onMembershipDeleted: this.onMembershipDeleted,
        membership: modalMember
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "org-users-list__confirm-modal"
      }, /*#__PURE__*/_react.default.createElement(_uiKit.FormModal, _extends({
        visible: [MODAL.RESET_CREDENTIALS, MODAL.RESEND_INVITATION].includes(openedModal),
        onClose: this.closeModal
      }, this.getConfirmModalProps()))), /*#__PURE__*/_react.default.createElement(_uiKit.List, {
        history: history,
        loading: loading,
        data: orgMemberships,
        totalResults: orgMemberships.length,
        listKey: "membershipId",
        filters: filters,
        onFiltersChange: this.handleFiltersChange,
        renderListItem: this.renderListItem,
        maxDisplayNum: 40,
        filtersRightAddon: !ssoConfig ? /*#__PURE__*/_react.default.createElement(InviteUsersButton, {
          className: "org-users-list__invite-btn",
          type: "SECONDARY",
          small: true,
          onClick: this.openModal({
            modalName: MODAL.INVITE_USERS
          }),
          permissions: orgPermissions
        }, "Invite Users") : void 0
      }));
    }
  }]);

  return UsersList;
}(_react.Component);

exports.default = UsersList;